import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import {
  CreateBuildingAreaCommand,
  GetBuildingAreasByBuildingCommand,
  GetBuildingAreaByIdCommand,
  UpdateBuildingAreaCommand,
  CreateBuildingAreasCommand,
  UpdateBuildingAreasCommand,
} from './building-area.commands';
import {
  CreatedBuildingAreaEvent,
  CreatedBuildingAreasEvent,
  GotAllBuildingAreasEvent,
  GotBuildingAreaByIdEvent,
  UpdateBuildingAreasEvent,
  UpdatedBuildingAreaEvent,
  UpdatedStatusBuildingAreaEvent,
} from './building-area.events';

@Injectable()
export class BuildingAreaEffects {
  prefix = 'building-area';
  createBuildingAreaCommand: Observable<Action<string>> & CreateEffectMetadata;
  getBuildingAreasByBuildingCommand: Observable<Action<string>> & CreateEffectMetadata;
  getBuildingAreaByIdCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateBuildingAreaCommand: Observable<Action<string>> & CreateEffectMetadata;
  createBuildingAreasCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.createBuildingAreaCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      CreateBuildingAreaCommand,
      CreatedBuildingAreaEvent,
      this.prefix,
    );
    this.createBuildingAreasCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      CreateBuildingAreasCommand,
      CreatedBuildingAreasEvent,
      this.prefix,
    );
    this.createBuildingAreasCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdateBuildingAreasCommand,
      UpdateBuildingAreasEvent,
      this.prefix,
    );
    this.getBuildingAreasByBuildingCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetBuildingAreasByBuildingCommand,
      GotAllBuildingAreasEvent,
      this.prefix,
    );
    this.getBuildingAreaByIdCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetBuildingAreaByIdCommand,
      GotBuildingAreaByIdEvent,
      this.prefix,
    );
    this.updateBuildingAreaCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdateBuildingAreaCommand,
      UpdatedBuildingAreaEvent,
      this.prefix,
    );
  }
}
